App.controller('educationResource', ['$scope', '$state', '$localStorage', '$loading', 'toastr', '$timeout',
    'ngDialog', '$window', '$http', '$sessionStorage', 'Api', 'systemService', 'organizationService', 'ProfessionalService', 'RecordService',

    function ($scope, $state, $localStorage, $loading, toastr, $timeout, ngDialog, $window, $http,
              $sessionStorage, Api, systemService, organizationService, ProfessionalService, RecordService) {

        var token = $localStorage['token'];
        if (token) {
            // allowed to access this controller

            var viewModel = this;
            viewModel.logoImage = $localStorage.logoImage;
            viewModel.bannerImage = $localStorage.bannerImage;
            viewModel.init = init;
            viewModel.init();

            function loadResourceUrls(resources) {
                if (!resources || resources.length === 0) {
                    console.warn('No resources available to load URLs.');
                    return;
                }
    
                const recordIds = resources
                    .map(resource => resource.id);
    
                if (recordIds.length === 0) {
                    console.warn('No valid record IDs found in resources.');
                    return;
                }
    
                for (let i = 0; i < recordIds.length; i++) {
                    const recordId = recordIds[i];
                    const resource = resources[i];
    
                    if (!recordId) {
                        console.warn(`Invalid recordId at index ${i}. Skipping...`);
                        continue;
                    }
                    try {
                        const url = RecordService.download({
                            auth: token,
                            recordId: recordId,
                            attachmentType: 'image'
                        });
    
                        if (url && url.trim() !== '') {
                            resource.file = url;
                        } else {
                            console.warn(`Download URL not found for recordId: ${recordId}`);
                        }
                    } catch (error) {
                        console.error(`Error fetching download URL for recordId ${recordId}:`, error);
                    }
                }
            }


            async function init() {
                $timeout(() => $loading.start('splash'));
                try {
                    const token = $localStorage['token'];
                    const { affiliations, isMarketplace } =
                        await ProfessionalService.get(token, { select: { affiliations: 1, isMarketplace: 1}});
                    let res;
                    if(!isMarketplace && (affiliations || []).length === 1){
                        res = await organizationService
                            .get(token, _.get(affiliations, '[0].organization._id'), { select: { resources: 1 }});
                    } else {
                        res = await systemService.getSettings($localStorage['token'], { select: { resources: 1 } })
                    }
                    viewModel.resources = res.resources;
                    loadResourceUrls(res.resources)
                    $scope.$apply();
                }catch (e) {
                    toastr.error(e.message);
                } finally {
                    $loading.finish('splash');
                }
            }


        } else {
            window.location.hash = '/login';
            window.location.reload();
        }

    }
]);